<ng-template
	[ngIfElse]="content"
	[ngIf]="text"
	>{{ text }}</ng-template
>
<ng-template #content>
	<ng-content />
</ng-template>
